/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Messages_CustomizeInputs */

const cs_messages_customize = /** @type {(inputs: Messages_CustomizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upravit dlaždice`)
};

const en_messages_customize = /** @type {(inputs: Messages_CustomizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Customize tiles`)
};

/**
* | output |
* | --- |
* | "Customize tiles" |
*
* @param {Messages_CustomizeInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const messages_customize = /** @type {((inputs?: Messages_CustomizeInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Messages_CustomizeInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_messages_customize(inputs)
	return cs_messages_customize(inputs)
});